import configData from "../config/config.json";
/*
export async function postUpdatedAccountInfo(username, firstname, lastname, emailaddress, phone, roles, managerId, webuserId) {
    console.log("header webuserid: ", webuserId);
    try{
        const url = configData.CCBHTableauAPIServer + "/UpdateAccountInformation";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{"Content-Type": 'application/json',
                     "WebuserID": webuserId
            },
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "managerId": managerId,
                    "roles": [
                        roles
                    ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
};
*/
export async function addNewEmployee(firstname, lastname, emailaddress, phone, role, managerId){
    try{
        const url = configData.CCBHTableauAPIServer + "/AddNewUser";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify(
                {
                    "firstName": firstname,
                    "lastName": lastname,
                    "username": "",
                    "phoneNumber": phone,
                    "email": emailaddress,
                    "title": "string",
                    "managerId": managerId,
                    "roles": [
                      role
                    ],
                    "userType": "",
                    "entites": [
                      {
                        "name": "",
                        "id": "",
                        "type": 0,
                        "typeDescription": "",
                        "role": role,
                        "enabled": true 
                      }
                    ],
                    "lastLoginDate": "",
                    "directReportEmployees": [],
                    "userID": ""
                  }
                ),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('Added User: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
}

export async function postUpdateUserFirstTimeLogin(username, firstname, lastname, emailaddress, phone, password){
    try{
        const url = configData.CCBHTableauAPIServer + "/updatefirsttimelogin";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                    "username": username,
                    "firstName": firstname,
                    "lastName": lastname,
                    "emailAddress": emailaddress,
                    "phone": phone,
                    "password": password,
                    "managerId": 'managerId',
                    "roles": [ ]
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }        
}

export async function postResetPassword(username){
    try{
        const url = configData.CCBHTableauAPIServer + "/password/reset";
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                    "webuserID": username,
                }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('update first time: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    } 
};

export const postUserAccountUnlock = async(webuserID) => {
    try{
        const url = configData.CCBHTableauAPIServer + "/unlock?username=" + webuserID;
        
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('post account unlock: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

export async function userAccountUnlock(webuserId){
    return await postUserAccountUnlock(webuserId);
};

export async function registerDevice(webuserId, fingerprint, browser, os, device){
    try{
        const url = configData.CCBHTableauAPIServer + "/register";
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                "webuserId": webuserId,
                "fingerPrint": String(fingerprint),
                "deviceprint": browser + "-" + os + "-" + device
            }),
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('post register device: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};

/// probably unneeded now
export const checkDeviceRegistration = async(webuserId, fingerprint, browser, os, device) => {
    try{
        const url = configData.CCBHTableauAPIServer + "/checkregistration";
        const response = await fetch(url, {
            method: "POST",
            headers:{'Content-Type': 'application/json'},
            body:JSON.stringify({
                "webuserId": webuserId,
                "fingerPrint": String(fingerprint),
                "deviceprint": browser + "-" + os + "-" + device
            })
        });
        console.log(response);
        const responseJson = await response.json();
        console.log('post register device: ', responseJson);

        return responseJson;
    }catch(err){
        console.log(err.message);
    }
};